import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';
import { Routes, Route, Navigate } from 'react-router-dom';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import styles from './settings.module.css';
import EventAutomation from './event';
import EffectAutomation from './effect';
import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import { PasswordUpdateForm } from './password';
import AdminsSettings from './admins';
import { Spacer } from 'app/member/layouts/generic';

const NAVITEMS = [
  {
    title: 'Password',
    path: '/settings/password'
  },
  {
    title: 'Admins',
    path: '/settings/admins'
  },
  {
    title: 'Automation Events',
    path: '/settings/event'
  },
  {
    title: 'Automation Effects',
    path: '/settings/effect'
  }
];

const SettingsModule = () => {
  const dispatch = useDispatch();
  const [nav_items, setNavItems] = useState(NAVITEMS);

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Settings', path: '.' }]));
    setNavItems(NAVITEMS);
  }, [dispatch]);

  return (
    <PageContentWrapper>
      <header>
        <SlidingNav nav_items={nav_items} />
      </header>
      <Spacer multiple={4} />
      <section className={styles.content}>
        <Routes>
          <Route path="password" element={<PasswordUpdateForm />} />
          <Route path="admins" element={<AdminsSettings />} />
          <Route path="effect" element={<EffectAutomation />} />
          <Route path="effect/:id" element={<EffectAutomation />} />
          <Route path="event" element={<EventAutomation />} />
          <Route path="event/:id" element={<EventAutomation />} />
          <Route path="*" element={<Navigate to="password" replace />} />
        </Routes>
      </section>
    </PageContentWrapper>
  );
};

export default SettingsModule;
